import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const metropolis: ProjectContentData = {
  id: 'metropolis',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'Polygon',
          name: 'Blockchain Network',
          description: (
            <span>
              The blockchain network
              <br />
              where you will claim the
              <br />
              <b>$CLAY</b> Tokens
            </span>
          ),
        },
        {
          id: 'clay',
          value: '$CLAY',
          name: 'Token Ticker',
          description: (
            <span>
              The symbol representing
              <br />
              the token
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: (
            <span>
              The total number of <b>$CLAY</b>
              <br />
              tokens in total supply
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '7.8%',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              The percentage of <b>$CLAY</b> <br />
              tokens that will be trading at TGE
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$2,980,150',
          name: 'Initial Market Cap',
          description: (
            <span>
              The market value of
              <br />
              circulating tokens at TGE
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$50,000',
          description: (
            <span>
              The amount aimed to be
              <br />
              raised in the IDO
            </span>
          ),
        },
        {
          id: 'token-price',
          name: 'Token Price',
          value: '$0.038',
          description: (
            <span>
              The price per <b>$CLAY</b> token
              <br />
              during the IDO
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The type of crypto
              <br />
              accepted for
              <br />
              participating in the IDO
            </span>
          ),
        },
        {
          id: 'refund-policy',
          name: 'Refund Policy',
          value: '24 hours',
          description: (
            <span>
              The time frame in which
              <br />
              you can request a refund from TGE
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '15%',
          name: 'At TGE',
          description: (
            <span>
              The percentage of tokens
              <br />
              available for claim of
              <br />
              TGE
              <br />
            </span>
          ),
        },
        {
          id: 'cliff',
          value: 'No Cliff',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '9 months',
          name: 'Linear Vesting',
          description: (
            <span>
              The time over which the <br />
              remaining tokens will be released
            </span>
          ),
        },
        {
          id: 'claim-via-presail',
          value: 'Claim via MagicSquare Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              The platform handling
              <br />
              the token distribution
              <br />
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'sale-start',
          value: 'January 27th',
          name: 'Sale Start',
          description: (
            <span>
              The starting date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'sale-end',
          value: 'January 29th',
          name: 'Sale End',
          description: (
            <span>
              The closing date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'TBD',
          description: (
            <span>
              The <b>$CLAY</b> token launch
              <br />
              date
            </span>
          ),
        },
        {
          id: 'distribution-start',
          name: 'Token Distribution Start',
          value: 'TBD',
          description: (
            <span>
              The <b>$CLAY</b> token claim
              <br />
              date
            </span>
          ),
        },
      ],
    },
  ],
};
